module.exports = __webpack_public_path__ + "img/icon_play.815cd332.svg";